/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Max_Tps_Switch_To_One_BlockInputs */



/**
* | output |
* | --- |
* | "Switch to Max TPS (1 block)" |
*
* @param {Metric_Max_Tps_Switch_To_One_BlockInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_max_tps_switch_to_one_block = /** @type {((inputs?: Metric_Max_Tps_Switch_To_One_BlockInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Max_Tps_Switch_To_One_BlockInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Switch to Max TPS (1 block)")
});